/* Generated by scripts/apply-brand.js from src/data/products.json — do not edit by hand */
import type { Product } from "./productTypes";
import img0 from "../assets/course-cards/mrcgp.jpg";
import img1 from "../assets/course-cards/msra.jpg";

export const BRAND_PRODUCTS: readonly Product[] = [
  {
    "title": "MSRA",
    "id": "msra",
    "price": 50,
    "comingSoon": false,
    "description": "2,300+ clinical MCQs, 2,000+ EMQ part questions (600+ EMQ groups of 3), and 700+ SJTs (professional dilemmas)—medic-reviewed and aligned to real MSRA format and difficulty.",
    "length": "6 months",
    "css": "",
    "cardImage": "course-cards/msra.jpg",
    "subjectNames": [
      "MSRA"
    ],
    "trialable": true
  },
  {
    "title": "MRCGP AKT",
    "id": "mrcgp_akt",
    "price": 99,
    "comingSoon": false,
    "description": "6,000 questions—built for the MRCGP AKT. Covers clinical medicine, evidence-based practice, and primary care organisation and management.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/mrcgp.jpg",
    "subjectNames": [
      "MRCGP AKT",
      "MRCGP"
    ],
    "legacyClassNames": [
      "MRCGP"
    ],
    "trialable": true
  }
];

export const CARD_IMAGES: Record<string, string> = {
  "course-cards/mrcgp.jpg": img0,
  "course-cards/msra.jpg": img1,
};
